module.exports = __webpack_public_path__ + "img/Villa_Borna_32.424cd878.jpg";